import { hasFlag } from 'country-flag-icons'

export default defineNuxtPlugin(() => {
  return {
    provide: {
      countryFlag: (iso?: string) => {
        if (!iso) {
          return ''
        }

        if (iso === 'en') {
          iso = 'gb'
        }

        iso = iso.toUpperCase()
        if (!hasFlag(iso)) {
          iso = 'EU'
        }
        return `https://purecatamphetamine.github.io/country-flag-icons/3x2/${iso}.svg`
      },
    },
  }
})
